import withSuspense from "../../hocs/withSuspense";
import { SettingsProps, Settings } from "./Settings";
import { SettingsSkeleton } from "./SettingsSkeleton/SettingsSkeleton";
import { SettingsError } from "./SettingsError/SettingsError";

export const SettingsWithSuspense = withSuspense<SettingsProps>(Settings, {
  FallbackComponent: SettingsError,
  loading: <SettingsSkeleton />,
});
